/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionUserConfirmation';

const ActionUserConfirmationManager: ActionManagerFn<
  'ActionUserConfirmation'
> = (platform: Platform): ActionManager<'ActionUserConfirmation'> => {
  return {
    ...baseActionManager(platform, 'ActionUserConfirmation'),
    isChildAllowed: (page, item, childType) =>
      ['ActionOnConfirm', 'ActionOnCancel'].includes(childType),
    defaultValue,
    props: {
      ...baseActionProps,
      title: {
        label: 'Confirmation Dialog Title',
        type: 'expression',
        returnType: async () => 'string',
        required: true,
      },
      message: {
        label: 'Confirmation Message',
        type: 'expression',
        returnType: async () => 'string',
        required: true,
      },
    },
    name: 'User Confirmation',
    getDisplayText: (item) => item.props.message.value,
    icon: { iconName: 'exclamation-triangle' },
    description: `Use this action to get the user's confirmation before performing an irreversible action such as Delete Record.

- On Confirm - When the user click on the Yes button on the confirmation dialog, all the actions under \`On Confirm\` child actions will get executed.
- On Cancel - When the user click on the Cancel button on the confirmation dialog or closes the dialog by pressing escape or cross icon on the top right corner, all the actions under \`On Cancel\` child actions will get executed.
`,
  };
};

export default ActionUserConfirmationManager;
